import * as ser from './SerUtil.js'
import { hashObject } from '../SharedUtils.js'

/**
 * Handles saving and loading a serializable object to/from localStorage.
 * Skips saves until after the first load, and skips redundant saves when
 * the serialized data has not changed.
 */
export class LocalStorageSaver {
  constructor(storageKey, target) {
    this.storageKey = storageKey
    this.target = target
    this.loaded = false
    this.lastSavedHash = null
  }

  loadFromStorage() {
    try {
      const dataString = localStorage.getItem(this.storageKey)
      if (dataString) {
        const data = JSON.parse(dataString)
        ser.readFromJson(this.target, data)
        this.lastSavedHash = hashObject(data)
      }
      this.loaded = true
    } catch (error) {
      console.warn(`Failed to load from localStorage (${this.storageKey}):`, error)
      this.loaded = true
    }
  }

  async save() {
    if (!this.loaded) {
      return
    }
    try {
      const data = ser.writeToJson(this.target)
      const hash = hashObject(data)
      if (hash !== this.lastSavedHash) {
        localStorage.setItem(this.storageKey, JSON.stringify(data))
        this.lastSavedHash = hash
      }
    } catch (error) {
      console.warn(`Failed to save to localStorage (${this.storageKey}):`, error)
    }
  }
}
